import axios from "axios";
import { useMemo } from "react";
import { useAuth } from "@clerk/react";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const pub = axios.create({ baseURL: `${API}/public` });

export const money = (c) => `$${((c || 0) / 100).toFixed(2)}`;
export const toCents = (s) => Math.round(parseFloat(String(s).replace(/[^0-9.]/g, "") || "0") * 100);
export const uid = () => (window.crypto?.randomUUID ? window.crypto.randomUUID() : String(Math.random()).slice(2));

export const errMsg = (e) => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d[0]?.msg || "Invalid input";
  return e?.message || "Something went wrong";
};

function useAuthed(prefix) {
  const { getToken } = useAuth();
  return useMemo(() => {
    const inst = axios.create({ baseURL: `${API}/${prefix}` });
    inst.interceptors.request.use(async (cfg) => {
      cfg.headers.Authorization = `Bearer ${await getToken()}`;
      return cfg;
    });
    return inst;
  }, [getToken, prefix]);
}

export const useOwnerApi = () => useAuthed("owner");


export const staffApi = (token) =>
  axios.create({ baseURL: `${API}/staff`, headers: token ? { "X-Staff-Token": token } : {} });

export async function downloadBlob(promise, filename) {
  const res = await promise;
  const url = URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}
